<template>
    <div>
        {{ ActDescBtn }}
        <v-container fluid  class="pa-0">
            <v-row max-height="48px" height="48px">
                <v-col v-if="!isDialogMode">
                    <ContenidoBase :titulo="'Crear Producto Movil'" :descripcion="'Crear un Producto Movil'"
                        :EstadoBtn="EstadoBtn" @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="newwnuevo"
                        @MethodGuardar="save" @MethodEliminar="remove" @MethodAnular="anular"
                        @MethodImprimir="imprimirList" />
                </v-col>

                <v-col v-else class="pt-0 align-center justify-space-between pa-3">
                    <div dense class="d-flex align-center justify-space-between pa-3"
                        style="background-color: #3f51b5; color: white;">
                        <h2 class="text-h6 font-weight-light">Creación de Producto Rápido</h2>
                        <v-btn fab small color="grey darken-4" @click="$emit('closeCreacionProductoDialog')">
                            <i style="font-size: 20px; color: white;" class="fa fa-close"></i>
                        </v-btn>
                    </div>
                </v-col>
            </v-row>

            <!-- contenido central ------------------------------------------------------------------------------ -->
                    <!-- Formulario -->
                    <v-card class="px-2 grey lighten-3 overflow-auto" :class="!isDialogMode ? 'mt-10' : ''">
                        <v-form ref="formProductoMovil" @submit.prevent="" v-model="valid" lazy-validation class="px-2">
                            <v-row>

                                <v-col cols="12" sm="6">

                                    <v-autocomplete dense outlined label="Almacen" style="font-size: 13px;"
                                        v-model="almacen" :items="almacenComboItems" ref="almacen"
                                        item-text="descripcion" @focus="findAllAlmacenes" return-object :rules="[rules.almacenRequired]">
                                        <template v-slot:prepend>
                                            <i style="font-size: 20px;" class="fa fa-sitemap"></i>
                                        </template>
                                    </v-autocomplete>

                                    <v-row dense class="items-center">
                                        <v-col cols="10">
                                            <v-text-field label="Codigo de Barra" dense outlined ref="codigoBarra"
                                                style="font-size: 13px;" v-model="unidadProducto.codigobarra"
                                                @keyup.enter="findByCodigoBarra">
                                                <template v-slot:prepend>
                                                    <i style="font-size: 20px;" class="fa fa-list-ol"></i>
                                                </template>
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="2" class="pl-0 mt-2">
                                            <v-btn small color="primary" @click="findByCodigoBarra">
                                                <i style="font-size: 20px;" class="fa fa-search"></i>
                                            </v-btn>
                                        </v-col>
                                    </v-row>

                                    <v-combobox dense outlined label="Descripcion" style="font-size: 13px;"
                                        v-model="productoModel" :items="descripcionComboitems"
                                        item-text="productos.descripcion" :search-input.sync="searchQuery"
                                        @update:search-input="findAllProductos" @keyup.enter="seleccionarPrimerElemento"
                                        ref="descripcionProducto" return-object :rules="[rules.required]">
                                        <template v-slot:prepend>
                                            <i style="font-size: 20px;" class="fa fa-book"></i>
                                        </template>
                                    </v-combobox>

                                    <v-combobox dense outlined label="Departamento" style="font-size: 13px;"
                                        v-model="departamentoModel" :items="departamentoComboItems"
                                        item-text="descripcion" @focus="findAllDepartamentos" return-object>
                                        <template v-slot:prepend>
                                            <i style="font-size: 20px;" class="fa fa-sitemap"></i>
                                        </template>
                                    </v-combobox>

                                    <v-text-field label="Referencia" dense outlined style="font-size: 13px;"
                                        v-model="unidadProducto.productos.referencia">
                                        <template v-slot:prepend>
                                            <i style="font-size: 20px;" class="fa fa-list-ol"></i>
                                        </template>
                                    </v-text-field>

                                    <v-combobox label="ITBIS" dense outlined style="font-size: 13px;"
                                        v-model="unidadProducto.productos.impuesto" :items="itbisComboItems"
                                        item-text="descripcion" @focus="findAllImpuestos">
                                        <template v-slot:prepend>
                                            <i style="font-size: 20px;" class="fa fa-list-ol"></i>
                                        </template>
                                    </v-combobox>

                                </v-col>

                                <v-col cols="12" sm="6" class="mb-3">

                                    <v-text-field type="number" min="0.0" step="0.1" label="Precio" dense outlined
                                        style="font-size: 13px;" v-model.number="unidadProducto.precio"
                                        :rules="[rules.required]" @focus="$event.target.select()">
                                        <template v-slot:prepend>
                                            <i style="font-size: 20px;" class="fa fa-money"></i>
                                        </template>
                                    </v-text-field>

                                    <v-text-field type="number" min="0.0" step="0.1" label="Costo" dense outlined
                                        style="font-size: 13px;" v-model="unidadProducto.costo"
                                        :rules="[rules.required]" @focus="$event.target.select()">
                                        <template v-slot:prepend>
                                            <i style="font-size: 20px;" class="fa fa-money"></i>
                                        </template>
                                    </v-text-field>

                                    <v-row dense>
                                        <v-col>
                                            <v-text-field label="Cantidad" dense outlined style="font-size: 13px;"
                                                v-model="cantidad" ref="cantidadProducto" @keyup.enter="save"
                                                :rules="[rules.quantity]" inputmode="numeric" pattern="[0-9]"
                                                @focus="$event.target.select()">
                                                <template v-slot:prepend>
                                                    <i style="font-size: 20px;" class="fa fa-list-ol"></i>
                                                </template>
                                            </v-text-field>
                                        </v-col>

                                        <v-col>
                                            <v-combobox label="Unidad" dense outlined style="font-size: 13px;"
                                                v-model="unidadProducto.unidades" :items="unidadComboItems"
                                                item-text="descripcion" @focus="findAllUnidades" return-object
                                                :rules="[rules.required]">
                                                <template v-slot:prepend>
                                                    <i style="font-size: 20px;" class="fa fa-list-ol"></i>
                                                </template>
                                            </v-combobox>
                                        </v-col>
                                    </v-row>

                                    <v-row dense>
                                        <v-col v-if="unidadProducto.listExistenciaAlmacen >= 0">
                                            <v-text-field type="number" label="Existencias" dense outlined
                                                style="font-size: 13px;" v-model="unidadProducto.listExistenciaAlmacen"
                                                disabled>
                                                <template v-slot:prepend>
                                                    <i style="font-size: 20px;" class="fa fa-list-ol"></i>
                                                </template>
                                            </v-text-field>
                                        </v-col>

                                        <v-col>
                                            <v-text-field type="number" min="1" label="Factor" dense outlined
                                                style="font-size: 13px;" v-model="unidadProducto.factor"
                                                :rules="[rules.required]" disabled>
                                                <template v-slot:prepend>
                                                    <i style="font-size: 20px;" class="fa fa-list-ol"></i>
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row v-if="isDialogMode" class="align-center justify-space-around">
                                        <div>
                                            <v-btn color="grey" class="mx-2" @click="limpiarForm">
                                                Nuevo
                                            </v-btn>

                                            <v-btn color="success" class="mx-2" @click="save">
                                                Salvar
                                            </v-btn>
                                        </div>
                                    </v-row>
                                </v-col>

                            </v-row>
                        </v-form>

                    </v-card>
                    <!-- Formulario -->

            <!-- fn contenido central ------------------------------------------------------------------------------------->
            <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
            <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraSecundariaAprir">
                <div class="overflow-y-auto" v-bind:style="{
                    'max-height': this.windowSize.height - 96 + 'px',
                    'max-width': '325px',
                    width: '325px',
                }"></div>
            </td>
            <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
            <!-- Alerta ------------------------------------------------------------------------------------------>
            <v-snackbar v-model="alerta.estado" :color="alerta.color" :vertical="true" :timeout="alerta.time" absolute>
                {{ alerta.message }}
                <v-btn dark text @click="alerta.estado = false">Close</v-btn>
            </v-snackbar>
            <!-- fn Alerta ------------------------------------------------------------------------------------------>
            <!-- Indicador de ejecucion ------------------------------------------------------------------------------------------>
            <div v-if="enEjecucion" class="form-loading-indicator">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
            <!-- fn Indicador de ejecucion ------------------------------------------------------------------------------------------>
        </v-container>
    </div>
</template>

<script>
import VueAutonumeric from "../../components/VueAutonumeric";
import { EventBus } from "../../event-bus";
import ContenidoBase from "../../components/ContenidoBase";
import { get } from "http";

export default {
    components: {
        VueAutonumeric,
        ContenidoBase,
    },

    created() {
        var json = {
            titulo: "Precio Producto",
            descripcion: "Ver Precio de los Productos",
            save: false,
            eliminar: false,
            anular: false,
            nuevo: false,
            imprimir: false,
            btnBarraDi: false,
        };
        EventBus.$emit("anularBotonesAccion", json);
    },

    mounted() {
        this.$refs.almacen.focus()
    },

    props: {
        isDialogMode: {
            required: false,
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            windowSize: { width: "auto", height: "auto" },
            valid: true,
            BarraTablaDinamicaAprir: false,
            BarraSecundariaAprir: false,
            configuraciones: null,
            producto: {
                codigo: undefined,
                codigoBarra: "",
                descripcion: "",
                departamento: "",
                referencia: "",
                precio: 0.0,
                costo: 0.0,
                cantidad: 1,
                unidad: "",
                factor: 0,
                itbis: ""
            },
            movimientoInventario: {
                documentoinventario: "",
                movimientoInventarioDetalle: {
                    producto: "",
                    almacen: "",
                    unidad: "",
                    cantidad: "",
                    costo: "",
                    valor: "",
                    impuesto: "",
                    borrado: false
                },
                borrado: false,
            },
            unidadProducto: {
                codigobarra: undefined,
                unidades: "",
                productos: {
                    descripcion: "",
                    departamento: {
                        descripcion: "",
                    },
                    referencia: "",
                    impuesto: null,
                    servicio: false,
                    calcularprecio: true,
                    imprimirEtiqueta: true,
                    incluirimpuestoenprecio: null
                },
                precio: "0.0",
                costo: "0.0",
                porbeneficio: 0,
                existencias: 0,
                listExistenciaAlmacen: -1,
                factor: 1,
                unidadcompra: true,
                unidadminima: true,
                borrado: false
            },
            cantidad: 0,
            almacen: "",
            isScannerInput: false,
            lastKeyTime: 0,
            searchQuery: "",

            itbisComboItems: [],
            descripcionComboitems: [],
            departamentoComboItems: [],
            almacenComboItems: [],
            unidadComboItems: [],

            enEjecucion: false,
            funcionOfCodigo: null,

            alerta: {
                estado: false,
                color: 'success',
                message: '',
                time: 0
            },

            EstadoBtn: {
                BarraTablaDinamicaAprir: false,
                nuevo: false,
                guardar: false,
                eliminar: false,
                anular: false,
                imprimir: false,
                vercuenta: false,
                guardartemporal: false,
                restaurartemporal: false,
                importarDato: false,
                cargarProducto: false,
                ImprimirproductoInv: false,
            },

            rules: {
                required: (value) => !!value || "Required.",
                quantity: (value) => {
                    if (this.unidadProducto.unidadesProductosPK != null) {
                        return value > 0 || "El valor debe ser mayor que cero"
                    }
                    return value > -1 || "El valor no debe ser menor que cero"
                },
                edad: [
                    (val) => val > 10 || `Edad debe ser mayor a 10`,
                    (val) => val < 70 || `Edad debe ser menor a 120`,
                ],
                counter: (value) =>
                    (value && value.length <= 50) || "Max 20 characters",
                RTel: (value) => value != 10 || `telefono debe tener 10 digitos`,
                almacenRequired: () => {
                    if (this.cantidad > 0 && (this.almacen == "" || this.almacen == null)){
                        return "Se requiere un almacen destino"
                    }
                    return true
                }
            },
        };
    },

    methods: {
        abrirTabla() {
            this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;
        },

        showAlert(message, type, time) {
            this.alerta.message = message;
            this.alerta.color = type;
            this.alerta.time = time
            this.alerta.estado = true;
        },

        seleccionarPrimerElemento() {
            if (this.descripcionComboitems.length > 0 && this.searchQuery) {
                this.productoModel = this.descripcionComboitems[0];

                if (this.$refs.descripcionProducto) {
                    this.$refs.descripcionProducto.blur();
                }

                this.$nextTick(() => {
                    this.$refs.cantidadProducto.focus()
                });
            }
        },

        findByCodigoBarra() {
            const barcode = this.unidadProducto.codigobarra.trim()

            this.$axios
                .get(
                    this.$hostname +
                    this.$hName +
                    "/unidades-productos/findByCodigoBarraAndUnidadMinima/" +
                    barcode, { params: { unidadMinima: true, descripcionAlmacen: this.almacen.descripcion } }
                )
                .then((res) => {
                    if (res.data.length > 0) {
                        const data = res.data[0]
                        this.unidadProducto = data
                        this.$refs.cantidadProducto.focus()
                        this.funcionOfCodigo = this.findByCodigoBarra.bind(this)
                    } else {
                        this.findByCodigoSistema()
                    }
                });
        },

        findByCodigoSistema() {
            const barcode = this.unidadProducto.codigobarra.slice(0, 6)

            this.$axios
                .get(
                    this.$hostname +
                    this.$hName +
                    "/unidades-productos/findByCodigoProductoAndUnidadMinima/" +
                    barcode, { params: { unidadMinima: true, descripcionAlmacen: this.almacen.descripcion } }
                )
                .then((res) => {
                    if (res.data.length > 0) {
                        const data = res.data[0]
                        this.unidadProducto = data
                        // this.unidadProducto.codigobarra = data.productos.codigo
                        this.funcionOfCodigo = this.findByCodigoBarra.bind(this);
                        this.$refs.cantidadProducto.focus()
                    } else {
                        this.findByCodigoAnterior()
                    }
                });
        },

        findByCodigoAnterior() {
            const barcode = this.unidadProducto.codigobarra.trim()

            this.$axios
                .get(
                    this.$hostname +
                    this.$hName +
                    "/unidades-productos/findByCodigoAnteriorAndUnidadMinima/" +
                    barcode, { params: { unidadMinima: true, descripcionAlmacen: this.almacen.descripcion } }
                )
                .then((res) => {
                    if (res.data.length > 0) {
                        const data = res.data[0]
                        this.unidadProducto = data
                        // this.unidadProducto.codigobarra = data.productos.codigoanterior
                        this.funcionOfCodigo = this.findByCodigoAnterior.bind(this)
                        this.$refs.cantidadProducto.focus()
                    } else {
                        console.log("Codigo anterior no encontrado");
                        this.$refs.codigoBarra.focus()
                    }
                });
        },

        findAllAlmacenes() {
            this.$nextTick(() => {
                this.$axios
                    .get(this.$hostname + this.$hName + "/almacen")
                    .then((res) => {
                        this.almacenComboItems = res.data
                    });
            });
        },

        findAllProductos(val) {
            this.$axios
                .get(
                    this.$hostname + this.$hName + "/unidades-productos/findByDescripcionProducto"
                    , {
                        params: {
                            descripcion: val,
                        }
                    })
                .then((res) => {
                    this.descripcionComboitems = res.data
                });
        },

        findAllImpuestos() {
            this.$axios
                .get(this.$hostname + this.$hName + "/impuestos/findall")
                .then((res) => {
                    this.itbisComboItems = res.data
                });
        },

        findAllDepartamentos() {
            this.$axios
                .get(this.$hostname + this.$hName + "/departamento/activo")
                .then((res) => {
                    this.departamentoComboItems = res.data
                });
        },

        findAllUnidades() {
            return this.$axios
                .get(this.$hostname + this.$hName + "/unidad/findall")
                .then((res) => {
                    this.unidadComboItems = res.data
                });
        },

        formatNumber(number) {
            return number
                .toFixed(2)
                .toString()
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        },

        applyItbisLogic() {
            if (this.unidadProducto.productos.incluirimpuestoenprecio != null) { return }
            if (this.unidadProducto.productos.impuesto != null) {
                this.unidadProducto.productos.incluirimpuestoenprecio = this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido
            } else {
                this.unidadProducto.productos.incluirimpuestoenprecio = false
            }
        },

        calcularPrecios() {
            var tasa = 0;
            if (this.unidadProducto.productos.incluirimpuestoenprecio == true && this.unidadProducto.productos.impuesto != null) {
                tasa = this.unidadProducto.productos.impuesto.tasa / 100
            }
            if (this.unidadProducto.porbeneficio != 0 && this.unidadProducto.costo != 0 && this.unidadProducto.precio == 0) {
                this.unidadProducto.precio = this.unidadProducto.costo * (1 + (this.unidadProducto.porbeneficio / 100)) * (1 + tasa)
            }
            if (this.unidadProducto.porbeneficio != 0 && this.unidadProducto.precio != 0 && this.unidadProducto.costo == 0) {
                this.unidadProducto.costo = (this.unidadProducto.precio / (1 + (this.unidadProducto.porbeneficio / 100))) / (1 + tasa)
            }
            if (this.unidadProducto.costo != 0 && this.unidadProducto.precio != 0 && this.unidadProducto.porbeneficio == 0) {
                this.unidadProducto.porbeneficio = (((this.unidadProducto.precio / (1 + tasa)) / this.unidadProducto.costo) - 1) * 100
                this.unidadProducto.porbeneficio = this.unidadProducto.porbeneficio.toFixed(2)
            }
        },

        validarFormulario(){
            if (this.cantidad > 0 && (this.almacen == "" || this.almacen == null) ){
                this.$refs.almacen.validate()
                this.showAlert("Seleccione un almacen", 'error', 3000)
                this.$refs.almacen.focus()
                return true
            }

            return false
        },

        save() {
            if (this.$refs.formProductoMovil.validate()) {
                if (this.validarFormulario()) {
                    return
                }

                this.applyItbisLogic()
                this.calcularPrecios()
                this.enEjecucion = true
                this.$axios
                    .post(this.$hostname + this.$hName + "/unidades-productos/save", this.unidadProducto)
                    .then((res) => {
                        if (this.cantidad > 0) {
                            this.unidadProducto = res.data
                            this.makeMovimientoInventario()
                        } else if (this.cantidad == 0) {
                            this.limpiarForm();
                            this.showAlert("Salvado exitoso", 'success', 4000)
                        }
                    })
                    .catch((error) => {
                        this.enEjecucion = false
                        console.log("error al salvar", error);
                        this.showAlert('Error al salvar el producto', 'error', 4000);
                    });
            } else {
                this.showAlert('Producto invalido', 'error', 4000);
                console.log("Error guardando");
            }
        },

        makeMovimientoInventario() {
            this.movimientoInventario = {
                documentoinventario: "",
                movimientosinventarioDetalleList: [],
                comentario: "Entrada de producto nuevo",
                activado: true,
                empresa: 1,
                referencia: "",
                borrado: false,
                fecha: new Date()
            }

            let detalle = {
                producto: this.unidadProducto.productos,
                almacen: this.almacen,
                unidad: this.unidadProducto.unidades,
                cantidad: this.cantidad,
                costo: this.unidadProducto.costo,
                valor: this.unidadProducto.existencias * this.unidadProducto.costo,
                impuesto: "",
                borrado: false
            };

            this.movimientoInventario.movimientosinventarioDetalleList.push(detalle);

            // Primero buscar el documento
            this.$axios
                .get(this.$hostname + this.$hName + "/documento-inv/entradasysalida")
                .then((res) => {
                    let documento = res.data
                    documento = documento.filter(doc => doc.operacion.codigo == 5)[0]
                    this.movimientoInventario.documentoinventario = documento

                    // Establecer el impuesto en el detalle de la lista
                    if (this.unidadProducto.productos.impuesto &&
                        this.unidadProducto.productos.impuesto.tasa !== undefined) {
                        this.movimientoInventario.movimientosinventarioDetalleList[0].impuesto = this.unidadProducto.productos.impuesto.tasa;
                    } else {
                        this.movimientoInventario.movimientosinventarioDetalleList[0].impuesto = 0;
                    }

                    // Enviar el movimiento de inventario
                    return this.$axios.post(
                        this.$hostname + this.$hName + "/entradasalida/save",
                        this.movimientoInventario
                    );
                })
                .then((res) => {
                    this.showAlert('Movimiento hecho correctamente', 'success', 4000);
                    this.limpiarForm();
                })
                .catch((error) => {
                    this.enEjecucion = false
                    console.error("Error en el proceso de movimiento de inventario", error);
                    this.showAlert('Error en el proceso de movimiento de inventario', 'error', 4000);
                });
        },

        limpiarForm() {
            this.movimientoInventario = {
                documentoinventario: "",
                movimientoInventarioDetalle: {
                    producto: "",
                    almacen: "",
                    unidad: "",
                    cantidad: "",
                    costo: "",
                    valor: "",
                    impuesto: "",
                    borrado: false
                },
                borrado: false,
            }
            this.cantidad = 0

            this.unidadProducto = {
                codigobarra: undefined,
                unidades: "",
                productos: {
                    descripcion: "",
                    departamento: {
                        descripcion: "",
                    },
                    referencia: "",
                    impuesto: "",
                    servicio: false,
                    calcularprecio: true,
                    imprimirEtiqueta: true
                },
                precio: "0.0",
                costo: "0.0",
                existencias: 0,
                factor: 1,
                unidadcompra: true,
                unidadminima: true,
                borrado: false
            }
            this.enEjecucion = false
            this.$refs.codigoBarra.focus();
            this.$refs.formProductoMovil.resetValidation()
        },

        remove() { },
        anular() { },
        imprimir() { },
        nuevo() { },
        newwnuevo() {
            this.limpiarForm()
        },
        imprimirList() { },
    },

    watch: {
        almacen(newAlmacen, oldAlmacen) {
            
            if (newAlmacen != "" && this.unidadProducto.productos.descripcion != "" ){
                this.funcionOfCodigo()
            }
        }
    },

    computed: {
        ActDescBtn() {
            // if (this.producto.codigo > 0) {
            //     this.EstadoBtn = {
            //         BarraTablaDinamicaAprir: false,
            //         nuevo: true,
            //         guardar: true,
            //         eliminar: false,
            //         anular: false,
            //         imprimir: false,
            //         vercuenta: false,
            //         guardartemporal: false,
            //         restaurartemporal: false,
            //         importarDato: false,
            //         cargarProducto: false,
            //         ImprimirproductoInv: false,
            //     }
            // }
            // if (this.producto.codigo == 0 || !this.producto.codigo) {
            //     this.EstadoBtn = {
            //         BarraTablaDinamicaAprir: false,
            //         nuevo: false,
            //         guardar: false,
            //         eliminar: false,
            //         anular: false,
            //         imprimir: false,
            //         vercuenta: false,
            //         guardartemporal: false,
            //         restaurartemporal: false,
            //         importarDato: false,
            //         cargarProducto: false,
            //         ImprimirproductoInv: false,
            //     }
            // }

            if (!this.enEjecucion) {
                this.EstadoBtn.guardar = true
                this.EstadoBtn.nuevo = true
            } else {
                this.EstadoBtn.guardar = false
                this.EstadoBtn.nuevo = false
            }
            this.windowSize = JSON.parse(
                JSON.stringify(this.$store.getters.GetwindowSize)
            );
        },
        productoModel: {
            get() {
                return this.unidadProducto.productos.descripcion
            },
            set(val) {
                if (!val) return
                if (typeof val === 'string') {
                    this.unidadProducto.productos.codigo = 0
                    this.unidadProducto.productos.existencias = this.cantidad
                    this.unidadProducto.productos.descripcion = val
                }

                if (typeof val === 'object') {
                    if (this.unidadComboItems.length === 0) {
                        this.findAllUnidades().then(() => {
                            this.unidadProducto = val;
                            this.unidadProducto.codigobarra = this.unidadProducto.codigobarra.trim() ?
                                this.unidadProducto.codigobarra : this.unidadProducto.productos.codigo;

                            const unidadExiste = this.unidadComboItems.some(item =>
                                item.codigo === val.unidades.codigo
                            );
                        });
                    } else {
                        this.unidadProducto = val;
                        this.unidadProducto.codigobarra = this.unidadProducto.codigobarra.trim() ?
                            this.unidadProducto.codigobarra : this.unidadProducto.productos.codigo;

                        const unidadExiste = this.unidadComboItems.some(item =>
                            item.codigo === val.unidades.codigo
                        );
                    }
                }
            }
        },
        departamentoModel: {
            get() {
                return this.unidadProducto.productos.departamento.descripcion
            },
            set(val) {
                if (!val) return
                this.unidadProducto.productos.departamento = val
            }
        }
    },
};
</script>

<style>
.form-loading-indicator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: transparent;
    padding: 20px;
    border-radius: 4px;
    z-index: 1;
}
</style>